import { GRID_CHECKBOX_SELECTION_COL_DEF, GridColDef } from '@mui/x-data-grid';
import { renderGridCheckboxCell } from './GridCheckboxCell';
import { renderGridCheckboxHeader } from './GridCheckboxHeader';
import { renderGridClearSelectionHeader } from './GridClearSelectionHeader';

export const getCheckboxColumn = (
  numRows: number,
  disabled?: boolean,
  isRowSelectable?: (row: Record<string, any>) => boolean
): GridColDef => ({
  ...GRID_CHECKBOX_SELECTION_COL_DEF,
  renderHeader: renderGridCheckboxHeader(numRows, disabled),
  renderCell: renderGridCheckboxCell(numRows, disabled, isRowSelectable),
});

export const getCheckboxColumnWithClearSelection = (numRows: number, disabled?: boolean): GridColDef => ({
  ...GRID_CHECKBOX_SELECTION_COL_DEF,
  renderHeader: renderGridClearSelectionHeader(numRows, disabled),
  renderCell: renderGridCheckboxCell(numRows, disabled),
});
